import ClusteredBar from './ClusteredBar';

export default ClusteredBar;
